export const splitAppLoginCallbackMessage = (message = "") => {
  const messageParts = String(message || "")
    .split(/\r?\n/)
    .map((part) => part.trim())
    .filter(Boolean);

  return {
    title: messageParts[0] || "",
    content: messageParts.slice(1).join("\n"),
  };
};
